import { render, staticRenderFns } from "./adminDigitalForms.vue?vue&type=template&id=68ca166c&scoped=true"
import script from "./adminDigitalForms.vue?vue&type=script&lang=js"
export * from "./adminDigitalForms.vue?vue&type=script&lang=js"
import style0 from "./adminDigitalForms.vue?vue&type=style&index=0&id=68ca166c&prod&lang=css"
import style1 from "./adminDigitalForms.vue?vue&type=style&index=1&id=68ca166c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ca166c",
  null
  
)

export default component.exports